var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"owc-text-media-module-text-block wb-grid-row",class:{
    'owc-text-media-module-text-block--dark': _vm.isDarkModeOn,
  }},[(_vm.subtitle)?_c('p',{staticClass:"owc-text-media-module-text-block__subtitle wb-grid-col-mq1-12",domProps:{"innerHTML":_vm._s(_vm.subtitle)}}):_vm._e(),(_vm.headline)?_c('h2',{staticClass:"owc-text-media-module-text-block__headline wb-grid-col-mq1-12",domProps:{"innerHTML":_vm._s(_vm.headline)}}):_vm._e(),(_vm.description)?_c('p',{class:[
      // Full width when there is a media block
      _vm.containsMedia ? 'wb-grid-col-mq3-12' : 'wb-grid-col-mq3-8',
      _vm.hasHeadline ? 'owc-text-media-module-text-block--has-headline' : '',
      'owc-text-media-module-text-block__description owc-rte-stylings',
      'wb-grid-col-mq1-12',
    ],domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }